import * as Rx from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Like pluck, but plucks from nested properties of a list of objects instead
 */
export function pluckList<T, P1 extends keyof T>(
  property1: P1,
): (
  source$: Rx.Observable<ReadonlyArray<T>>,
) => Rx.Observable<ReadonlyArray<T[P1]>> {
  return map(xs => xs.map(x => x[property1]));
}
